<template>
  <div>
    <a-input-search
      placeholder="Search account"
      style="width: 100%;"
      @change="onSearch"
    />
    <a-list item-layout="horizontal" :data-source="datas">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <div slot="description">Email: {{ item.email }}</div>
          <a slot="title">
            <a-checkbox
              :checked="onChecked(item)"
              @change="(e) => onChangeChecked(item, e)"
            >
              {{ item.fullname || item.username }}
            </a-checkbox>
          </a>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
      style="text-align: right;"
    >
      <a-button style="float: left;" @click="close">
        Close
      </a-button>
      <a-button
        style="margin-right: 10px;"
        @click="resetChecked"
        :disabled="disableDelete"
      >
        Deselect
      </a-button>
      <a-button
        type="danger"
        :loading="loadingBtn"
        @click="onUnAsignUsersToAppInPlatform"
        :disabled="disableDelete"
      >
        Remove
      </a-button>
    </div>
  </div>
</template>
<script>
import changeAlias from "@/services/changeAlias";
import query from "../../../../constants/query";
export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
    refreshUserAccessAfterUpdated: {
      type: Function,
      required: true,
    },
    userCanAccess: {
      type: Array,
      required: true,
    },
    idAppConfig: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userHasCheckedIds: [],
      loadingBtn: false,
      datas: [],
      disableDelete: true,
    };
  },
  watch: {
    userHasCheckedIds() {
      if (this.userHasCheckedIds?.length > 0) {
        this.disableDelete = false;
      } else {
        this.disableDelete = true;
      }
    },
  },
  created() {
    this.datas = [...this.userCanAccess];
  },
  methods: {
    async onChangeChecked(item, e) {
      await this.onUpdatedUserHasCheckedIds(item, e);
    },
    resetChecked() {
      this.userHasCheckedIds = [];
      if (this.userCanAccess?.length > 0) {
        for (let i in this.userCanAccess) {
          if (this.userCanAccess[i].checked) {
            this.$set(this.userCanAccess, i, {
              ...this.userCanAccess[i],
              checked: false,
            });
          }
        }
      }
    },
    onChecked(item) {
      if (this.userHasCheckedIds?.length > 0) {
        const index = this.userHasCheckedIds.findIndex((id) => id === item.id);
        if (index >= 0) {
          return true;
        }
      }
      return false;
    },
    onUpdatedUserHasCheckedIds(item, e) {
      if (e?.target?.checked && item.id) {
        this.userHasCheckedIds.push(item.id);
      } else {
        if (this.userHasCheckedIds?.length > 0) {
          const index = this.userHasCheckedIds.findIndex(
            (id) => id === item.id
          );
          if (index >= 0) {
            this.userHasCheckedIds.splice(index, 1);
          }
        }
      }
    },
    onSearch(e) {
      const value = e.target.value;
      if (value) {
        this.datas = this.userCanAccess.filter(
          (e) =>
            changeAlias(e.username).indexOf(value) > -1 ||
            changeAlias(e.fullname).indexOf(value) > -1 ||
            changeAlias(e.email).indexOf(value) > -1
        );
      } else {
        this.datas = [...this.userCanAccess];
      }
    },
    onUnAsignUsersToAppInPlatform() {
      if (this.disableDelete) {
        return false;
      }
      this.loadingBtn = true;
      if (!this.idAppConfig) {
        throw new Error("cannot get id app platform");
      }
      this.$apollo
        .mutate({
          mutation: query.unAssignUsersToAppInPlatform,
          variables: {
            userIds: this.userHasCheckedIds,
            id: this.idAppConfig,
          },
        })
        .then(({ data }) => {
          if (data?.unAssignUsersToAppInPlatform?.userCanAccess?.length >= 0) {
            this.refreshUserAccessAfterUpdated(
              data.unAssignUsersToAppInPlatform.userCanAccess
            );
          }
          this.form = {};
          this.loadingBtn = false;
          this.$notification.success({
            message: "Thông báo",
            description: "Cập nhật tài khoản thành công!",
          });
          this.close();
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cập nhật tài khoản lỗi!",
          });
          console.log("Cập nhật tài khoản lỗi!", error);
        });
    },
  },
};
</script>
<style lang="css" scoped></style>
